exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-mapa-strony-js": () => import("./../../../src/pages/mapa-strony.js" /* webpackChunkName: "component---src-pages-mapa-strony-js" */),
  "component---src-templates-expert-jsx": () => import("./../../../src/templates/expert.jsx" /* webpackChunkName: "component---src-templates-expert-jsx" */),
  "component---src-templates-page-jsx": () => import("./../../../src/templates/page.jsx" /* webpackChunkName: "component---src-templates-page-jsx" */),
  "component---src-templates-post-jsx": () => import("./../../../src/templates/post.jsx" /* webpackChunkName: "component---src-templates-post-jsx" */)
}

